module.exports = __webpack_public_path__ + "media/images/sites/health/bruna-a43eb42714ac4b8919273e1fc493906d.jpg";